import { getOAuth2MachineToMachineFields } from './getOAuth2MachineToMachineFields.js';
import { getStandardAuthFields } from './getStandardAuthFields.js';

const toNormalizedFieldKey = (field) => {
  return String(field?.key || '')
    .trim()
    .toLowerCase();
};

const isVisibleAuthArgument = (argument) => {
  return argument?.hidden !== true && argument?.key;
};

const sortAuthArguments = (argumentsList = []) => {
  return [...argumentsList].filter(isVisibleAuthArgument).sort((left, right) => {
    const leftSequence = Number.isFinite(left?.sequence) ? left.sequence : 500;
    const rightSequence = Number.isFinite(right?.sequence) ? right.sequence : 500;
    return leftSequence - rightSequence;
  });
};

export const getMergedAuthFields = ({ authType, auth, appSpecificFields } = {}) => {
  const standardFields = getStandardAuthFields({ authType, auth });
  const definedFields = Array.isArray(appSpecificFields) ? appSpecificFields.filter(isVisibleAuthArgument) : sortAuthArguments(auth?.arguments || []);
  const definedFieldKeys = new Set(definedFields.map((field) => toNormalizedFieldKey(field)).filter(Boolean));
  const filteredStandardFields = standardFields.filter((field) => {
    return !definedFieldKeys.has(toNormalizedFieldKey(field));
  });
  const machineToMachineFields = getOAuth2MachineToMachineFields({
    auth,
    existingFields: [...filteredStandardFields, ...definedFields]
  });

  return [...filteredStandardFields, ...machineToMachineFields, ...definedFields];
};
